import React from "react";
import {
  Box,
  Drawer,
  Typography,
  IconButton,
  Divider,
  Button,
  Stack,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import useScreenSize from "../../../hooks/useScreenSize";
import { brand } from "../../../theme/themePrimitives";

type FilterItem = {
  id: string;
  name: string;
  checked?: boolean;
};

type FilterGroup = {
  title: string;
  items: FilterItem[];
};

type Props = {
  filtersList: FilterGroup[];
  showFilter: boolean;
  setShowFilter: (v: boolean) => void;
  handleCheckboxChange: (groupIndex: number, itemIndex: number) => void;
  saveFilters: () => void;
  clearFilters: () => void;
};

export const Filter: React.FC<Props> = ({
  filtersList,
  showFilter,
  setShowFilter,
  handleCheckboxChange,
  saveFilters,
  clearFilters,
}) => {
  const { isMobile } = useScreenSize();

  return (
    <Drawer
      id="manage-assignments-filter-drawer"
      anchor="right"
      open={showFilter}
      onClose={() => setShowFilter(false)}
      slotProps={{
        paper: {
          sx: {
            backgroundColor: "white",
            boxSizing: "border-box",
            width: isMobile ? "100%" : "350px",
            padding: "1rem",
          },
        },
      }}
    >
      <Box
        sx={{
          width: 320,
          p: 2,
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h6">Filters</Typography>
          <IconButton
            id="manage-assignments-filter-close-button"
            onClick={() => setShowFilter(false)}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <Divider sx={{ my: 1 }} />

        <Box sx={{ flex: 1, overflow: "auto" }}>
          {filtersList.map((group, groupIndex) => (
            <Box key={group.title} sx={{ m: 1 }}>
              <Typography sx={{ mb: 1 }}>{group.title}</Typography>
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                {group.items.map((item, itemIndex) => (
                  <FormControlLabel
                    key={item.id}
                    control={
                      <Checkbox
                        checked={!!item.checked}
                        onChange={() =>
                          handleCheckboxChange(groupIndex, itemIndex)
                        }
                        size="small"
                      />
                    }
                    label={item.name}
                  />
                ))}
              </Box>
            </Box>
          ))}
        </Box>
        <Divider sx={{ my: 1 }} />
        <Stack direction="row" spacing={1} justifyContent="space-between">
          <Button
            sx={{
              borderRadius: "12px",
              backgroundColor: `${brand[600]} !important`,
              color: `white`,
              "&:hover": {
                bgcolor: `${brand[700]} !important`,
              },
            }}
            onClick={() => {
              saveFilters();
              setShowFilter(false);
            }}
          >
            Save
          </Button>
          <Button
            sx={{
              borderRadius: "12px",
              backgroundColor: "white",
              color: brand[600],
              "&:hover": {
                bgcolor: brand[50],
              },
              border: `1px solid ${brand[600]}`,
            }}
            onClick={() => {
              clearFilters();
              setShowFilter(false);
            }}
          >
            Clear all
          </Button>
        </Stack>
      </Box>
    </Drawer>
  );
};

export default Filter;
